import { computed, ComputedRef } from 'vue'

import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { CloseReviewEntryViewModel } from '@/presentation/viewmodels/review/closeReviewEntryViewModel'

export class CloseReviewEntryPresenter {
  private viewModel: CloseReviewEntryViewModel

  constructor(viewModel: CloseReviewEntryViewModel) {
    this.viewModel = viewModel
  }

  get entryList(): ComputedRef<ReviewEntry[]> {
    return this.viewModel.entryList
  }

  get hasEntryInList(): ComputedRef<boolean> {
    return computed(() => this.viewModel.entryList.value.length > 0)
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  async fetchReviewEntryList(userId: string, problemId: string): Promise<void> {
    if (this.isLoading.value) {
      console.log('Data fetch is already in progress')
      return
    }
    await this.viewModel.fetchReviewEntryList(userId, problemId)
  }
}
